import React, { useMemo } from 'react';
import uuid from 'uuid/v4';
import { cloneDeep } from 'lodash';
import CellContent from './CellContent';
import { getProcessedFilter, setHeightOfRows } from '../../../util/CrosstabUtils';

function PrivateEyeViewCellContent({ cellElementList, getGridRows, colEndIndex,
    highlightAndFilter, toggleCheckVal, handleProbabilitiesEditClick, partsToShow }) {

    const metricsList = cellElementList.map(item => { return item.isVisible; });
    const metricsCount = cellElementList.filter(item => item.isVisible);
    const newRows = cloneDeep(getGridRows);

    return useMemo(() => newRows.map((newRow, index) =>
      (<div key={uuid()} className="c-table--row" style={{ height: setHeightOfRows(partsToShow, newRow, index, toggleCheckVal) }}>
        {newRow.cellList.slice(0, colEndIndex).map(col => (<div key={uuid()} className="c-table-private-col">
          <CellContent
            cell={col}
            highlightAndFilter={highlightAndFilter}
            metricsList={metricsList}
            metricsCount={metricsCount.length}
            newHighlightAndFilter={getProcessedFilter(highlightAndFilter)}
            cellHeight={setHeightOfRows(partsToShow, newRow, index, toggleCheckVal, 'cell')}
            handleProbabilitiesEditClick={handleProbabilitiesEditClick}
          />
        </div>))
        }
      </div>)), [newRows, cellElementList, highlightAndFilter, toggleCheckVal.row, colEndIndex]);
  };

  
export default PrivateEyeViewCellContent;
